var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2872 11.1527C19.7551 11.1529 20.1345 11.5321 20.1345 12C20.1345 12.4679 19.7551 12.8471 19.2872 12.8473L12.848 12.8466V19.2755C12.848 19.7435 12.468 20.1235 12 20.1234C11.532 20.1234 11.152 19.7435 11.152 19.2755V12.8466L4.71211 12.848C4.24409 12.848 3.8648 12.4687 3.86482 12.0007C3.86507 11.5329 4.24425 11.1534 4.71211 11.1534L11.1527 11.1527L11.1527 4.71279C11.1529 4.24492 11.5321 3.86549 12 3.86551C12.4679 3.86552 12.8471 4.24493 12.8473 4.71279L12.848 11.152L19.2872 11.1527Z",
    fill: "#424752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/PLUS.0d42233b46464db4f5669ebd50cb5c2d.svg";
export { ForwardRef as ReactComponent };